module.exports = __webpack_public_path__ + "static/media/new_order.71de50bb.mp3";